// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__Pu4aq","productName":"Table_productName__3-L9c"};